import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TArticleDM from './TArticleDM'

export default class TProductCostingTreeDM extends Data {
	public static className = 'TProductCostingTreeDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	AlternateUnit?: number
	UnitPlannedPrice?: number
	DependentTime?: number
	IndependentTime?: number
	Quantity?: number
	JobCardQuantity?: number
	HeaderNodeRID?: number
	ProductCostingRID?: number
	RID?: number
	RecordMod?: number
	RecordES?: number
	RecordNo?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	ExchangeRateCalc?: number
	CurrencyCalc?: string
	UnitPlannedPriceCCalc?: number
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
}